/* eslint-disable */
import { httpRequest } from '@/request';
import { DataCollectBaseUrl } from '@/request/config';
import { cache, getUserAccount, isEmpty } from '@/utils';
import { encodeURIEncryptFE } from '@/utils/libs/JSEncrypt';
import TrackerQueue from '@/utils/Tracker/TrackerQueue';
import MonitorCore from '@insta/monitor-core';

function checkEleLoaded(src, eleType = 'script') {
  const s = document.querySelector(`${eleType}[src='${src}']`);
  // console.log(!!s, eleType, src);
  return !!s;
}

/**
 * ARMS监控
 */
export function Arms({ country }) {
  const monitor = MonitorCore.init();
  // 只有中国才注册ARMS
  if (country.code === 'CN') {
    monitor.registerSDK('ARMS', {
      pid: 'f8ds5tkidk@284e3d9e23f743f',
      release: __NEXT_DATA__.buildId,
      setUsername: () => encodeURIEncryptFE(getUserAccount('email')),
      c1: `${country.code}-${country.language}-${cache?.get('_ins_sid')}`,
    });
  }

  const areaConfig = {
    HZ: {
      pid: 'f8ds5tkidk@fd581721e71c0d2',
      endpoint: 'https://f8ds5tkidk-default-cn.rum.aliyuncs.com',
    },
    US: {
      pid: 'f8ds5tkidk@154b818c1d857bf',
      endpoint: 'https://f8ds5tkidk-default-us.rum.aliyuncs.com',
    },
  };
  const config = country.code === 'CN' ? areaConfig.HZ : areaConfig.US;

  monitor.registerSDK('RUMS', {
    pid: config.pid,
    endpoint: config.endpoint,
    version: window?.__NEXT_DATA__?.buildId,
    user: {
      name: encodeURIEncryptFE(getUserAccount('email')),
      tags: `${country.code}-${country.language}-${cache?.get('_ins_sid')}`,
    },
  });
}

function PushEngage({ country }) {
  // 区分正式环境和测试环境
  const config = {
    prod_src: 'https://clientcdn.pushengage.com/core/85113afe-acbc-475f-a4a4-ab8af2a51a6f.js',
    test_src: 'https://clientcdn.pushengage.com/core/bc1b3ff7-b9db-4831-9d7a-bb2cad22cde8.js',
  };

  const src = window.isProd ? config.prod_src : config.test_src;

  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = src;
  s.onload = function () {
    const code = country?.code;
    const map = {
      'CN': 'China',
      'JP': 'Japan',
      'Other': 'Overseas',
    };
    const init = map[code] || map.Other;
    window._peq = window._peq || [];
    window._peq.push(['init', init]);
  };
  document.head.appendChild(s);
}

function CrazyEgg() {
  const src = 'https://script.crazyegg.com/pages/scripts/0115/5248.js';
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  document.head.appendChild(s);
}

function BaiduHM({ country }) {
  const src = 'https://hm.baidu.com/hm.js?344a501b18a6b7cdd781be7b02994fd9';
  if (checkEleLoaded(src)) return;
  if (country?.code !== 'CN') return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  document.head.appendChild(s);
}

function Attentive({ country }) {
  const src = 'https://cdn.attn.tv/insta360/dtag.js';
  const code = country?.code;
  /**
   * 注意！注意！注意！
   * 2024年黑五期间，黑五的活动落地页暂时隐藏该弹窗
   * 不想在这里写一大堆的时间、地区限制了，活动下线了就删掉这一行吧
   * 如果下一年的黑五活动页需要开放，请关注这里
   */
  if (window.location.pathname === '/black-friday') return null;

  // 优惠弹窗期间下线CA地区attentive
  if (window.localStorage.getItem('activeSubModal') && ['CA'].includes(code)) return null;
  if (!['CA'].includes(code)) return null;
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  document.head.appendChild(s);
}

function TikTok({ country }) {
  if (country.code === 'CN') return;
  (function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    // eslint-disable-next-line no-multi-assign
    let ttq = (w[t] = w[t] || []);
    (ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ]),
      (ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          // eslint-disable-next-line prefer-rest-params
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      });
    for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    (ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      // eslint-disable-next-line no-undef
      return e;
    }),
      (ttq.load = function (e, n) {
        let i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        (ttq._i = ttq._i || {}),
          (ttq._i[e] = []),
          (ttq._i[e]._u = i),
          (ttq._t = ttq._t || {}),
          (ttq._t[e] = +new Date()),
          (ttq._o = ttq._o || {}),
          (ttq._o[e] = n || {});
        let o = document.createElement('script');
        (o.type = 'text/javascript'), (o.async = !0), (o.src = i + '?sdkid=' + e + '&lib=' + t);
        if (checkEleLoaded(o.src)) return;
        let a = document.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(o, a);
      });
    ttq.load('C8089ITGL1ARI64QSFBG');
    ttq.page();
  })(window, document, 'ttq');
}

function Linkedin({ country }) {
  if (country.code === 'CN') return;
  function addNoScript() {
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = 'https://px.ads.linkedin.com/collect/?pid=2215140&fmt=gif';

    const noscript = document.createElement('noscript');
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }

  (function (l) {
    const src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    if (checkEleLoaded(src)) return;
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    const s = document.getElementsByTagName('script')[0];
    const b = document.createElement('script');
    b.type = 'text/javascript';
    b.async = true;
    b.src = src;
    b.addEventListener('load', function () {
      const _linkedin_partner_id = '2215140';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      addNoScript();
      window?.InstaTrackerQueue?.consume('Linkedin');
    });
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
}

function FacebookPixel() {
  if (country.code === 'CN') return;
  (function (f, b, e, v, n, t, s) {
    if (checkEleLoaded(v)) return;
    if (f.fbq) return;
    n = f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '451591722489720');
  fbq.disablePushState = true;

  // Fb初次初始化页面跟踪
  const eventId = Math.random().toString(16).substr(3) + Date.now().toString(36);
  httpRequest({
    url: DataCollectBaseUrl + '/facebook/conversionsDataReporting',
    method: 'POST',
    data: {
      eventId,
      eventType: 12,
      eventSourceURL: document.URL,
    },
  }).catch((e) => {});
}

function Twitter({ country }) {
  if (country.code === 'CN') return;
  (function (e, t, n, s, u, a) {
    const src = 'https://static.ads-twitter.com/uwt.js';
    if (checkEleLoaded(src)) return;
    e.twq ||
      ((s = e.twq =
        function () {
          // eslint-disable-next-line prefer-rest-params
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }),
      (s.version = '1.1'),
      (s.queue = []),
      (u = t.createElement(n)),
      (u.async = !0),
      (u.src = src),
      (a = t.getElementsByTagName(n)[0]),
      a.parentNode.insertBefore(u, a));
    u.addEventListener('load', function () {
      const ID_MAP = {
        JP: 'o1op9',
        default: 'obvge',
      };
      const ConfigId = ID_MAP[country?.code] ?? ID_MAP.default;
      window.twq('config', ConfigId);
    });
  })(window, document, 'script');
}

function Bing({ country }) {
  if (country.code === 'CN') return;
  (function (w, d, t, r, u) {
    if (checkEleLoaded(r)) return;
    let f;
    let n;
    let i;
    (w[u] = w[u] || []),
      (f = function () {
        let o = { ti: '187042997' };
        (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
      }),
      (n = d.createElement(t)),
      (n.src = r),
      (n.async = 1),
      (n.onload = n.onreadystatechange =
        function () {
          let s = this.readyState;
          (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
        }),
      (i = d.getElementsByTagName(t)[0]),
      i.parentNode.insertBefore(n, i);
  })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq_2997');
}

function A8Tag({ country }) {
  const src = '//statics.a8.net/a8sales/a8sales.js';
  if (country.code !== 'JP') return null;
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  s.onload = () => {
    window?.InstaTrackerQueue?.consume('A8Tag');
  };
  document.body.appendChild(s);

  const eleSpan = document.createElement('span');
  eleSpan.id = 'a8sales';
  window.__next.appendChild(eleSpan);
}

function Yahoo({ country }) {
  const src = 'https://s.yimg.jp/images/listing/tool/cv/ytag.js';
  if (country.code !== 'JP') return null;
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  document.body.appendChild(s);

  window.yjDataLayer = window.yjDataLayer || [];
  function ytag() {
    // eslint-disable-next-line prefer-rest-params
    window.yjDataLayer.push(arguments);
  }
  ytag({
    type: 'yss_retargeting',
    config: {
      yahoo_ss_retargeting_id: '1001075541',
      yahoo_sstag_custom_params: {},
    },
  });
}

function Naver({ country }) {
  const src = '//wcs.naver.net/wcslog.js';
  if (country.code !== 'KR') return null;
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  s.onload = () => {
    try {
      window.wcs_add = window.wcs_add ?? {};
      window.wcs_add['wa'] = 's_24867fffe3b8';

      window._nasa = window._nasa ?? {};
      window.wcs.inflow('insta360.com');

      // 调用 log 收集函数
      window.wcs_do(window._nasa);
      window?.InstaTrackerQueue?.consume('Naver');
    } catch (e) {
      console.error('Naver init error', e);
    }
  };
  document.body.appendChild(s);
}

export function Forter({ app }) {
  (function () {
    if (app.isOrderResultPage) return;
    var eu = '22g4zl{5jf5fjtlv1forxgiurqw1qhw2vwdwxv';
    var siteId = '57b894dd3bd1';
    function t(t, e) {
      for (var n = t.split(''), r = 0; r < n.length; ++r) n[r] = String.fromCharCode(n[r].charCodeAt(0) + e);
      return n.join('');
    }
    function e(e) {
      return t(e, -_).replace(/%SN%/g, siteId);
    }
    function n() {
      var t = 'no' + 'op' + 'fn',
        e = 'g' + 'a',
        n = 'n' + 'ame';
      return window[e] && window[e][n] === t;
    }
    function r() {
      return !(!navigator.brave || 'function' != typeof navigator.brave.isBrave);
    }
    function o() {
      return document.currentScript && document.currentScript.src;
    }
    function i(t) {
      try {
        (F.ex = t),
          n() && F.ex.indexOf(V.uB) === -1 && (F.ex += V.uB),
          r() && F.ex.indexOf(V.uBr) === -1 && (F.ex += V.uBr),
          o() && F.ex.indexOf(V.nIL) === -1 && (F.ex += V.nIL),
          window.ftr__snp_cwc || (F.ex += V.s),
          C(F);
      } catch (e) {}
    }
    function a(t, e) {
      function n(o) {
        try {
          o.blockedURI === t && (e(), document.removeEventListener(r, n));
        } catch (i) {
          document.removeEventListener(r, n);
        }
      }
      var r = 'securitypolicyviolation';
      document.addEventListener(r, n),
        setTimeout(function () {
          document.removeEventListener(r, n);
        }, 2 * 60 * 1e3);
    }
    function c(t, e, n, r) {
      var o = !1;
      (t = 'https://' + t),
        a(t, function () {
          r(!0), (o = !0);
        });
      var i = document.createElement('script');
      (i.onerror = function () {
        if (!o)
          try {
            r(!1), (o = !0);
          } catch (t) {}
      }),
        (i.onload = n),
        (i.type = 'text/javascript'),
        (i.id = 'ftr__script'),
        (i.async = !0),
        (i.src = t);
      var c = document.getElementsByTagName('script')[0];
      c.parentNode.insertBefore(i, c);
    }
    function u(t, e, n) {
      var r = new XMLHttpRequest();
      if (
        (a(t, function () {
          n(new Error('CSP Violation'), !0), (isErrorEventCalled = !0);
        }),
        'withCredentials' in r)
      )
        r.open('GET', t, !0);
      else {
        if ('undefined' == typeof XDomainRequest) return;
        (r = new XDomainRequest()), r.open('GET', t);
      }
      (r.onload = function () {
        'function' == typeof e && e(r);
      }),
        (r.onerror = function (t) {
          if ('function' == typeof n && !isErrorEventCalled)
            try {
              n(t, !1), (isErrorEventCalled = !0);
            } catch (e) {}
        }),
        (r.onprogress = function () {}),
        (r.ontimeout = function () {
          'function' == typeof n && n('tim' + 'eo' + 'ut', !1);
        }),
        setTimeout(function () {
          r.send();
        }, 0);
    }
    function d() {
      u(
        y,
        function (n) {
          try {
            var r = n.getAllResponseHeaders().toLowerCase();
            if (r.indexOf(x.toLowerCase()) < 0) return;
            var o = n.getResponseHeader(x),
              i = t(o, -_ - 1);
            if (i) {
              var a = i.split(':');
              if (a && 3 === a.length) {
                var c = a[0],
                  u = a[1],
                  d = a[2];
                switch (u) {
                  case 'none':
                    A = c + T;
                    break;
                  case 'res':
                    A = c + T + d;
                    break;
                  case 'enc':
                    A = c + e('1forxgiurqw1qhw2vq2(VQ(2vfulsw1mv');
                    break;
                  case 'enc-res':
                    for (var s = '', v = 0, l = 0; v < 20; ++v)
                      s += v % 3 > 0 && l < 12 ? siteId.charAt(l++) : F.id.charAt(v);
                    var m = d.split('.');
                    if (m.length > 1) {
                      var h = m[0],
                        w = m[1];
                      A = c + T + h + '.' + s + '.' + w;
                    }
                }
                if (r.indexOf(S.toLowerCase()) >= 0) {
                  var p = n.getResponseHeader(S),
                    g = t(p, -_ - 1);
                  window.ftr__altd = g;
                }
                j(V.dUAL), setTimeout(f, k, V.dUAL);
              }
            }
          } catch (y) {}
        },
        function (t, e) {
          i(e ? V.uAS + V.cP : V.uAS);
        }
      );
    }
    function f(t) {
      try {
        var e = t === V.uDF ? L : A;
        if (!e) return;
        var n = function () {
            try {
              Q(), i(t + V.uS);
            } catch (e) {}
          },
          r = function (e) {
            try {
              Q(), (F.td = 1 * new Date() - F.ts), i(e ? t + V.uF + V.cP : t + V.uF), t === V.uDF && d();
            } catch (n) {
              i(V.eUoe);
            }
          };
        c(e, void 0, n, r);
      } catch (o) {
        i(t + V.eTlu);
      }
    }
    var s = 'fort',
      v = 'erTo',
      l = 'ken',
      m = s + v + l,
      h = 10,
      w = {
        write: function (t, e, n, r) {
          void 0 === r && (r = !0);
          var o, i;
          if (
            (n
              ? ((o = new Date()),
                o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3),
                (i = '; expires=' + o.toGMTString()))
              : (i = ''),
            !r)
          )
            return void (document.cookie = escape(t) + '=' + escape(e) + i + '; path=/');
          for (var a = 1, c = document.domain.split('.'), u = h, d = !0; d && c.length >= a && u > 0; ) {
            var f = c.slice(-a).join('.');
            document.cookie = escape(t) + '=' + escape(e) + i + '; path=/; domain=' + f;
            var s = w.read(t);
            (null != s && s == e) ||
              ((f = '.' + f), (document.cookie = escape(t) + '=' + escape(e) + i + '; path=/; domain=' + f)),
              (d = document.cookie.indexOf(t + '=' + e) === -1),
              a++,
              u--;
          }
        },
        read: function (t) {
          var e = null;
          try {
            for (var n = escape(t) + '=', r = document.cookie.split(';'), o = 32, i = 0; i < r.length; i++) {
              for (var a = r[i]; a.charCodeAt(0) === o; ) a = a.substring(1, a.length);
              0 === a.indexOf(n) && (e = unescape(a.substring(n.length, a.length)));
            }
          } finally {
            return e;
          }
        },
      },
      p = '13';
    p += 'ck';
    var g = function (t) {
        var e = function () {
          var e = document.createElement('link');
          return (
            e.setAttribute('rel', 'pre' + 'con' + 'nect'),
            e.setAttribute('cros' + 'sori' + 'gin', 'anonymous'),
            (e.onload = function () {
              document.head.removeChild(e);
            }),
            (e.onerror = function (t) {
              document.head.removeChild(e);
            }),
            e.setAttribute('href', t),
            document.head.appendChild(e),
            e
          );
        };
        if (document.head) {
          var n = e();
          setTimeout(function () {
            document.head.removeChild(n);
          }, 3e3);
        }
      },
      _ = 3,
      y = e(eu || '22g4zl{5jf5fjtlv1forxgiurqw1qhw2vwdwxv'),
      T = t('1forxgiurqw1qhw2', -_),
      x = t('[0Uhtxhvw0LG', -_),
      S = t('[0Fruuhodwlrq0LG', -_),
      A,
      L = e('(VQ(1fgq71iruwhu1frp2vq2(VQ(2vfulsw1mv'),
      E = e('(VQ(1fgq71iruwhu1frp2vqV2(VQ(2vfulsw1mv'),
      k = 10;
    window.ftr__startScriptLoad = 1 * new Date();
    var U = function (t) {
        var e = 1e3,
          n = 'ft' + 'r:tok' + 'enR' + 'eady';
        window.ftr__tt && clearTimeout(window.ftr__tt),
          (window.ftr__tt = setTimeout(function () {
            try {
              delete window.ftr__tt, (t += '_tt');
              var e = document.createEvent('Event');
              e.initEvent(n, !1, !1), (e.detail = t), document.dispatchEvent(e);
            } catch (r) {}
          }, e));
      },
      C = function (t) {
        var e = function (t) {
            return t || '';
          },
          n = e(t.id) + '_' + e(t.ts) + '_' + e(t.td) + '_' + e(t.ex) + '_' + e(p);
        w.write(m, n, 1825, !0), U(n), (window.ftr__gt = n);
      },
      D = function () {
        var t = w.read(m) || '',
          e = t.split('_'),
          n = function (t) {
            return e[t] || void 0;
          };
        return { id: n(0), ts: n(1), td: n(2), ex: n(3), vr: n(4) };
      },
      q = (function () {
        for (var t = {}, e = 'fgu', n = [], r = 0; r < 256; r++) n[r] = (r < 16 ? '0' : '') + r.toString(16);
        var o = function (t, e, r, o, i) {
            var a = i ? '-' : '';
            return (
              n[255 & t] +
              n[(t >> 8) & 255] +
              n[(t >> 16) & 255] +
              n[(t >> 24) & 255] +
              a +
              n[255 & e] +
              n[(e >> 8) & 255] +
              a +
              n[((e >> 16) & 15) | 64] +
              n[(e >> 24) & 255] +
              a +
              n[(63 & r) | 128] +
              n[(r >> 8) & 255] +
              a +
              n[(r >> 16) & 255] +
              n[(r >> 24) & 255] +
              n[255 & o] +
              n[(o >> 8) & 255] +
              n[(o >> 16) & 255] +
              n[(o >> 24) & 255]
            );
          },
          i = function () {
            if (window.Uint32Array && window.crypto && window.crypto.getRandomValues) {
              var t = new window.Uint32Array(4);
              return window.crypto.getRandomValues(t), { d0: t[0], d1: t[1], d2: t[2], d3: t[3] };
            }
            return {
              d0: (4294967296 * Math.random()) >>> 0,
              d1: (4294967296 * Math.random()) >>> 0,
              d2: (4294967296 * Math.random()) >>> 0,
              d3: (4294967296 * Math.random()) >>> 0,
            };
          },
          a = function () {
            var t = '',
              e = function (t, e) {
                for (var n = '', r = t; r > 0; --r) n += e.charAt((1e3 * Math.random()) % e.length);
                return n;
              };
            return (t += e(2, '0123456789')), (t += e(1, '123456789')), (t += e(8, '0123456789'));
          };
        return (
          (t.safeGenerateNoDash = function () {
            try {
              var t = i();
              return o(t.d0, t.d1, t.d2, t.d3, !1);
            } catch (n) {
              try {
                return e + a();
              } catch (n) {}
            }
          }),
          (t.isValidNumericalToken = function (t) {
            return (
              t &&
              t.toString().length <= 11 &&
              t.length >= 9 &&
              parseInt(t, 10).toString().length <= 11 &&
              parseInt(t, 10).toString().length >= 9
            );
          }),
          (t.isValidUUIDToken = function (t) {
            return t && 32 === t.toString().length && /^[a-z0-9]+$/.test(t);
          }),
          (t.isValidFGUToken = function (t) {
            return 0 == t.indexOf(e) && t.length >= 12;
          }),
          t
        );
      })(),
      V = {
        uDF: 'UDF',
        dUAL: 'dUAL',
        uAS: 'UAS',
        mLd: '1',
        eTlu: '2',
        eUoe: '3',
        uS: '4',
        uF: '9',
        tmos: ['T5', 'T10', 'T15', 'T30', 'T60'],
        tmosSecs: [5, 10, 15, 30, 60],
        bIR: '43',
        uB: 'u',
        uBr: 'b',
        cP: 'c',
        nIL: 'i',
        s: 's',
      },
      b = function (t, e) {
        for (var n = V.tmos, r = 0; r < n.length; r++) if (t + n[r] === e) return !0;
        return !1;
      };
    try {
      var F = D();
      try {
        F.id && (q.isValidNumericalToken(F.id) || q.isValidUUIDToken(F.id) || q.isValidFGUToken(F.id))
          ? (window.ftr__ncd = !1)
          : ((F.id = q.safeGenerateNoDash()), (window.ftr__ncd = !0)),
          (F.ts = window.ftr__startScriptLoad),
          C(F),
          (window.ftr__snp_cwc = !!w.read(m)),
          window.ftr__snp_cwc || (L = E);
        for (
          var I = 'for' + 'ter' + '.co' + 'm',
            R = 'ht' + 'tps://c' + 'dn9.' + I,
            B = 'ht' + 'tps://' + F.id + '-' + siteId + '.cd' + 'n.' + I,
            G = 'http' + 's://cd' + 'n3.' + I,
            O = [R, B, G],
            M = 0;
          M < O.length;
          M++
        )
          g(O[M]);
        var N = new Array(V.tmosSecs.length),
          j = function (t) {
            for (var e = 0; e < V.tmosSecs.length; e++) N[e] = setTimeout(i, 1e3 * V.tmosSecs[e], t + V.tmos[e]);
          },
          Q = function () {
            for (var t = 0; t < V.tmosSecs.length; t++) clearTimeout(N[t]);
          };
        b(V.uDF, F.ex) ? loadAlternate() : (j(V.uDF), setTimeout(f, k, V.uDF));
      } catch (H) {
        i(V.mLd);
      }
    } catch (H) {}
  })();
  document.addEventListener('ftr:tokenReady', function (evt) {
    var token = evt.detail;
    window.localStorage.setItem('ftr-token', token);
    console.log('forter is ready now');
  });
}

// TTD投广
export function TTD() {
  if (country.code === 'CN') return;
  const src = 'https://js.adsrvr.org/up_loader.1.1.0.js';
  const s = document.createElement('script');
  s.src = src;
  s.type = 'text/javascript';
  s.async = true;
  s.onload = () => {
    try {
      window.ttd_dom_ready(function () {
        if (typeof window.TTDUniversalPixelApi === 'function') {
          const universalPixelApi = new window.TTDUniversalPixelApi();
          window.__ttd = universalPixelApi;
          // 页面浏览，下载即发送
          window.__ttd?.init?.('n7q8h4r', ['k4kijfl'], 'https://insight.adsrvr.org/track/up');
        }
      });
    } catch (e) {
      console.error('TTD init error', e);
    }
  };
  document.body.appendChild(s);
}

// Volcengine DataTester
export function DataTester() {
  (function (win, export_obj) {
    win['LogAnalyticsObject'] = export_obj;
    if (!win[export_obj]) {
      function _collect() {
        _collect.q.push(arguments);
      }
      _collect.q = _collect.q || [];
      win[export_obj] = _collect;
    }
    win[export_obj].l = +new Date();
  })(window, 'collectEvent');

  const src = 'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.12.js';
  const s = document.createElement('script');
  s.src = src;
  s.type = 'text/javascript';
  s.async = true;
  s.onload = () => {
    try {
      if (!window?.collectEvent) return;
      window.collectEvent('init', {
        app_id: window?.isProd ? 10000019 : 10000021,
        channel_domain: 'https://snssdk.insta360.com',
        ab_channel_domain: 'https://snssdk.insta360.com',
        // log: true,
        autotrack: false,
        enable_ab_test: true,
        enable_ab_visual: false,
        enable_multilink: false,
        multilink_timeout_ms: 1000,
        // enable_debug: true,
      });
      window.collectEvent('start');
      const visitorId = cache.getCookie('flagship_visitor_id') || '';
      window.collectEvent('config', {
        user_unique_id: visitorId,
      });
      if (!isEmpty(TrackerQueue?.customQueue || [])) {
        const queue = TrackerQueue.customQueue;
        queue.forEach((payload) => {
          if (Array.isArray(payload)) window.collectEvent('beconEvent', ...payload);
          else window.collectEvent('beconEvent', payload);
        });
        TrackerQueue.customQueue = [];
      }
    } catch (e) {
      console.error('Volcengine init error', e);
    }
  };
  document.body.appendChild(s);
}

export function VWO({ country }) {
  if (country.code !== 'US') return;
  const src = 'https://dev.visualwebsiteoptimizer.com';
  if (checkEleLoaded(src)) return;
  const s = document.createElement('script');
  s.src = `${src}`;
  s.id = 'vwoCode';
  window._vwo_code ||
    (function () {
      var account_id = 1019689,
        version = 2.0,
        settings_tolerance = 2000,
        hide_element = 'body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
        /* DO NOT EDIT BELOW THIS LINE */
        f = false,
        w = window,
        d = document,
        v = d.querySelector('#vwoCode'),
        cK = '_vwo_' + account_id + '_settings',
        cc = {};
      try {
        var c = JSON.parse(localStorage.getItem('_vwo_' + account_id + '_config'));
        cc = c && typeof c === 'object' ? c : {};
      } catch (e) {}
      var stT = cc.stT === 'session' ? w.sessionStorage : w.localStorage;
      var code = {
        use_existing_jquery: function () {
          return typeof use_existing_jquery !== 'undefined' ? use_existing_jquery : undefined;
        },
        library_tolerance: function () {
          return typeof library_tolerance !== 'undefined' ? library_tolerance : undefined;
        },
        settings_tolerance: function () {
          return cc.sT || settings_tolerance;
        },
        hide_element_style: function () {
          return '{' + (cc.hES || hide_element_style) + '}';
        },
        hide_element: function () {
          return typeof cc.hE === 'string' ? cc.hE : hide_element;
        },
        getVersion: function () {
          return version;
        },
        finish: function () {
          if (!f) {
            f = true;
            var e = d.getElementById('_vis_opt_path_hides');
            if (e) e.parentNode.removeChild(e);
          }
        },
        finished: function () {
          return f;
        },
        load: function (e) {
          var t = this.getSettings(),
            n = d.createElement('script'),
            i = this;
          if (t) {
            n.textContent = t;
            d.getElementsByTagName('head')[0].appendChild(n);
            if (!w.VWO || VWO.caE) {
              stT.removeItem(cK);
              i.load(e);
            }
          } else {
            n.fetchPriority = 'high';
            n.src = e;
            n.type = 'text/javascript';
            n.onerror = function () {
              _vwo_code.finish();
            };
            d.getElementsByTagName('head')[0].appendChild(n);
          }
        },
        getSettings: function () {
          try {
            var e = stT.getItem(cK);
            if (!e) {
              return;
            }
            e = JSON.parse(e);
            if (Date.now() > e.e) {
              stT.removeItem(cK);
              return;
            }
            return e.s;
          } catch (e) {
            return;
          }
        },
        init: function () {
          if (d.URL.indexOf('__vwo_disable__') > -1) return;
          var e = this.settings_tolerance();
          w._vwo_settings_timer = setTimeout(function () {
            _vwo_code.finish();
            stT.removeItem(cK);
          }, e);
          var t = d.currentScript,
            n = d.createElement('style'),
            i = this.hide_element(),
            r = t && !t.async && i ? i + this.hide_element_style() : '',
            c = d.getElementsByTagName('head')[0];
          n.setAttribute('id', '_vis_opt_path_hides');
          v && n.setAttribute('nonce', v.nonce);
          n.setAttribute('type', 'text/css');
          if (n.styleSheet) n.styleSheet.cssText = r;
          else n.appendChild(d.createTextNode(r));
          c.appendChild(n);
          this.load(
            'https://dev.visualwebsiteoptimizer.com/j.php?a=' +
              account_id +
              '&u=' +
              encodeURIComponent(d.URL) +
              '&vn=' +
              version
          );
        },
      };
      w._vwo_code = code;
      code.init();
    })();
  document.head.appendChild(s);
}

export default {
  Arms,
  PushEngage,
  CrazyEgg,
  BaiduHM,
  Attentive,
  TikTok,
  Linkedin,
  FacebookPixel,
  Twitter,
  Bing,
  A8Tag,
  Yahoo,
  Naver,
  Forter,
  TTD,
  VWO,
  DataTester,
};
